angular.module('EdxReport', [
  'EdxClassroomReportModule',
  'EdxDistrictReportModule',
  'EdxReportCommonModule',
  'EdxSchoolReportModule',
  'EdxStudentReportModule',
  'EdxTeacherReportModule']);